import { NotificationManager } from 'react-notifications';
import axios from 'axios';

import { IFilter } from '../filters/types';

const FILTER_URL = 'api/v1/filter-elements';

export const fetchFiltersDictRequest = async (): Promise<IFilter[]> => {
  try {
    const res = await axios.get(FILTER_URL);
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch filters");
    return [];
  }
};
